module.exports = __webpack_public_path__ + "static/img/123.8190967d.png";